import React from "react";
import WindowFormsMyDashboard from "./WindowFormsMyDashboard";
import { personName } from "./WindowFormShared";

const submitterOf = (entry) => personName(entry?.submit_user);

// Quoter view: window RFQs assigned to me.
const WindowFormsAssignedDashboard = () => (
  <WindowFormsMyDashboard
    heading="My Assigned RFQs"
    subtitle="Window RFQs assigned to you — what needs action and where everything stands."
    fetchMode="assigned"
    detailBase="/windowdoor/staff/windowforms"
    actionStatuses={[
      "Submitted",
      "Under Review",
      "Reviewing Revisions",
      "Approved",
    ]}
    waitingStatuses={["Needs Revision", "Awaiting Sales Approval"]}
    doneStatuses={["Converted to Order"]}
    waitingLabel="Waiting on sales"
    attentionHints={{
      Submitted: "New assignment — start the review.",
      "Under Review": "In progress — send the quote when it's ready.",
      "Reviewing Revisions":
        "Sales updated the RFQ — review the revision and send an updated quote.",
      Approved:
        "Quote approved — record the order number once it's in Bistrack.",
    }}
    extraColumn={{
      title: "Submitted By",
      customFilterAndSearch: (term, rowData) =>
        submitterOf(rowData).toLowerCase().includes(term.toLowerCase()),
      customSort: (a, b) => submitterOf(a).localeCompare(submitterOf(b)),
      render: (rowData) => submitterOf(rowData),
    }}
    emptyMessage="No RFQs are assigned to you yet. New assignments will show up here."
  />
);

export default WindowFormsAssignedDashboard;
